import React, { useState, useEffect, useRef } from 'react';
import { useAnimation } from '../hooks/useAnimation';

const SelectStatScreen = ({ data, onSelectStatistic }) => {
  const [displayedName, setDisplayedName] = useState('');
  const { typewriterEffect, animateNumbers } = useAnimation();
  const statNumberRefs = useRef({});

  useEffect(() => {
    if (data?.player?.name) {
      typewriterEffect(setDisplayedName, data.player.name);
    }
  }, [data, typewriterEffect]);

  useEffect(() => {
    // Animate statistic buttons
    const buttons = document.querySelectorAll('.statistic-btn');
    buttons.forEach((button, index) => {
      setTimeout(() => {
        button.classList.add('animate-in');
        // Animate the number after button appears
        setTimeout(() => {
          const statName = data?.statistics[index];
          const statValue = data?.player?.stats?.[statName] || data?.player?.[statName];
          const numberElement = statNumberRefs.current[statName];
          if (numberElement && statValue) {
            animateNumbers(numberElement, statValue, 800);
          }
        }, 200);
      }, index * 150);
    });
  }, [data, animateNumbers]);

  const handleSelectStat = (statistic) => {
    onSelectStatistic(statistic);
  };

  if (!data) return null;

  // const playerStats = data.player.stats || data.player;

  return (
    <div className="screen active">
      <div className="card">
        <h2>Your Turn!</h2>
        <div>
          <h3>{displayedName}</h3>
          <p>Choose which statistic to compete on:</p>
        </div>
        <div>
          {data.statistics.map((stat) => {
            // const statValue = playerStats[stat] || data.player[stat];
            
            return (
              <button
                key={stat}
                className="statistic-btn"
                onClick={() => handleSelectStat(stat)}
              >
                <span>{stat}: </span>
                <span ref={el => statNumberRefs.current[stat] = el}>0</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SelectStatScreen;